import compileSymbols from '~/utils/compileSymbols';
const types = [
  'FETCH',
  'FETCH_SUCCESS',
  'FETCH_FAILED',
  'SAVE_DESIGN',
  'SAVE_SUCCESS',
  'SAVE_FAILED',
  'SET_SKIP_OVERVIEW',
  'UPDATE_ESTIMATED_PROFIT',
  'UPDATE_GOAL_QUANTITY',
  'UPDATE_PRINT_MINIMUM',
  'UPDATE_PROFIT',
  'UPDATE_SALE_PRICE'
];
export default compileSymbols(types, 'fundraising');
